import 'whatwg-fetch';
import { isLoading, isLoaded, isFailed, displayFailureToaster, DANGER_TOASTER } from '../';

const TIMEOUT_MS = 240000; // Necessary for large file uploads > 500MB

function fetchOrTimeout(url, config) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error(`fetch ${url} timed out`));
      // no op when the fetch finishes
      /* eslint-disable no-param-reassign */
      resolve = () => {};
      reject = () => {};
      /* eslint-enable no-param-reassign */
    }, TIMEOUT_MS);

    fetch(url, config)
      .then((res) => {
        clearTimeout(timeoutId);
        resolve(res);
      })
      .catch((err) => {
        clearTimeout(timeoutId);
        reject(err);
      });
  });
}

export function createFetchAction(type = null, {
  url,
  method = 'GET',
  body,
  headers = {
    Accept: '*/*',
  },
} = {}, fetchContext = null, metaData = {}) {
  if (!type) {
    throw new Error('An action type is required to create a fetch action');
  }
  if (!url) {
    throw new Error(`Please specify a url to create a ${type} fetch action`);
  }

  const errorStatus = (actionType, dispatch, metaDataObj, status, response) => {
    const {
      failureMessage = { type: DANGER_TOASTER, customComponent: null, exclusions: false },
      requestId = '',
    } = metaDataObj;
    const { exclusions, exclusionAction } = failureMessage;
    const isPageExcluded = exclusions && exclusions.some(e => (e.test(window.location.href)));
    if (!isPageExcluded) {
      if (typeof failureMessage === 'function') {
        dispatch(displayFailureToaster(fetchContext, failureMessage(status, response)));
      } else {
        dispatch(displayFailureToaster(fetchContext, failureMessage));
      }
    } else if (isPageExcluded && exclusionAction) {
      exclusionAction();
    }
    dispatch(isFailed(actionType, requestId));

    // Support for executing a fallbackAction action
    const { fallbackAction, errorCodes } = metaDataObj;
    if (fallbackAction && errorCodes.indexOf(status) > -1) {
      fallbackAction();
    }
  };

  const fetchInit = {
    method,
    headers,
    body,
  };

  const { requestId = '' } = metaData;

  return (dispatch, nextAction = () => {}) => {
    dispatch(isLoading(type, requestId));
    return fetchOrTimeout(url, fetchInit)
      .then((response) => {
        if (response.status >= 400) {
          return response.json()
            .then((res) => {
              errorStatus(type, dispatch, metaData, response.status, res);
              return null;
            });
        } else {
          return response.text()
            .then((text) => {
              const payload = text ? JSON.parse(text) : undefined;
              nextAction({ dispatch, result: payload });
              dispatch({ type, payload, meta: metaData });
            })
            .then(() => {
              dispatch(isLoaded(type, requestId));
            });
        }
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        if (window.console) console.log(e);
        errorStatus(type, dispatch, metaData);
      });
  };
}




// WEBPACK FOOTER //
// ./src/modules/helpers/fetch.js